import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-card-style3',
  templateUrl: './card-style3.component.html',
  styleUrls: ['./card-style3.component.css']
})
export class CardStyle3Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
